module.exports = __webpack_public_path__ + "img/zzs.152ff0e3.png";